/* TODAY. — rhode-inspired interaction layer. Dependency-free, defer-safe. */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Scroll reveal
     Adds .is-revealed to .today-reveal / .today-reveal-group when they
     enter the viewport. Reveals once, then stops observing.

     Note: the split header navigation is handled entirely in
     today-header.css. It deliberately does NOT move any DOM, because
     Savor's <overflow-list> element collapses unexpected children behind
     a "More" toggle.
     ------------------------------------------------------------------ */
  function initReveal() {
    var targets = document.querySelectorAll('.today-reveal, .today-reveal-group');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     Theme editor support
     Sections re-render without a page load in the editor, so reveal any
     newly loaded content immediately rather than leaving it invisible.
     ------------------------------------------------------------------ */
  function initEditorSupport() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    var showAll = function (event) {
      var scope = (event && event.target) || document;
      var els = scope.querySelectorAll ? scope.querySelectorAll('.today-reveal, .today-reveal-group') : [];
      els.forEach(function (el) { el.classList.add('is-revealed'); });
    };

    document.addEventListener('shopify:section:load', showAll);
    document.addEventListener('shopify:section:select', showAll);
    document.addEventListener('shopify:block:select', showAll);
  }

  function init() {
    initReveal();
    initEditorSupport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
